<script setup lang="ts">
import ContextMenu from '@/components/ui/contextMenu/ContextMenu.vue'
import { ShareFireOutbreakAlertEnum } from '../enums/ShareFireOutbreakAlert.enum'
import { computed } from 'vue'
import i18n from '@/VueI18n'

const props = defineProps<{
	seen: boolean
}>()

const emit = defineEmits<{
	(event: 'change', value: ShareFireOutbreakAlertEnum): void
}>()

const options = [
	{
		name: i18n.t('fireRiskDashboardShareOnWhatsapp') as string,
		icon: 'ic:baseline-whatsapp',
		event: ShareFireOutbreakAlertEnum.WHATSAPP,
	},
]

const iconColor = computed(() => (props.seen ? 'text-blue-base' : 'text-red-danger'))
</script>

<template>
	<context-menu
		:options="options"
		:icon-color="iconColor"
		@change="emit('change', $event)"
	/>
</template>
